import React from 'react';

const ProjectsIcon = (props) => {

  let { 
    height, 
    width, 
    iconColor,
  } = props;
  
  return (
      <svg 
        width={width ? width : '21px'} 
        height={height ? height : '19px'} 
        viewBox="0 0 21 19" 
        version="1.1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlnsXlink="http://www.w3.org/1999/xlink" >
          <title>Projects</title>
          <g id="V.4-Design-Change" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="company-filter--copy-2" transform="translate(-970.000000, -32.000000)" fillRule="nonzero" fill={iconColor}>
                  <path d={`M989.619565,34.4782609 L981.028261,34.4782609 C980.970435,34.4782609 980.912609,34.4534783 
                  980.871304,34.403913 L979.177826,32.3717391 C978.979565,32.1321739 978.690435,32 978.384783,32 
                  L974.336957,32 C973.766957,32 973.304348,32.4626087 973.304348,33.0326087 L973.304348,34.4782609 
                  L972.684783,34.4782609 C972.114783,34.4782609 971.652174,34.9408696 971.652174,35.5108696 
                  L971.652174,36.9565217 L971.032609,36.9565217 C970.462609,36.9565217 970,37.4191304 970,37.9891304 
                  L970,49.9673913 C970,50.5373913 970.462609,51 971.032609,51 L986.315217,51 C986.885217,51 
                  987.347826,50.5373913 987.347826,49.9673913 L987.347826,48.5217391 L987.967391,48.5217391 
                  C988.537391,48.5217391 989,48.0591304 989,47.4891304 L989,46.0434783 L989.619565,46.0434783 
                  C990.189565,46.0434783 990.652174,45.5808696 990.652174,45.0108696 L990.652174,35.5108696 
                  C990.652174,34.9408696 990.189565,34.4782609 989.619565,34.4782609 Z M986.521739,49.9673913 
                  C986.521739,50.0830435 986.43087,50.173913 986.315217,50.173913 L971.032609,50.173913 
                  C970.916957,50.173913 970.826087,50.0830435 970.826087,49.9673913 L970.826087,37.9891304 
                  C970.826087,37.8734783 970.916957,37.7826087 971.032609,37.7826087 L975.080435,37.7826087 
                  C975.138261,37.7826087 975.196087,37.8073913 975.237391,37.8569565 L977.112609,40.1121739 
                  C977.195217,40.2030435 977.31087,40.2608696 977.426522,40.2608696 L986.306957,40.2608696 
                  C986.422609,40.2608696 986.513478,40.3517391 986.513478,40.4673913 L986.513478,49.9673913 
                  L986.521739,49.9673913 Z M988.173913,47.4891304 C988.173913,47.6047826 988.083043,47.6956522 
                  987.967391,47.6956522 L987.347826,47.6956522 L987.347826,40.4673913 C987.347826,39.8973913 
                  986.885217,39.4347826 986.315217,39.4347826 L977.624783,39.4347826 L975.873478,37.3282609 
                  C975.675217,37.0886957 975.386087,36.9565217 975.080435,36.9565217 L972.478261,36.9565217 
                  L972.478261,35.5108696 C972.478261,35.3952174 972.56913,35.3043478 972.684783,35.3043478 
                  L976.732609,35.3043478 C976.790435,35.3043478 976.848261,35.3291304 976.889565,35.3786957 
                  L978.764783,37.633913 C978.847391,37.7247826 978.963043,37.7826087 979.078696,37.7826087 
                  L987.95913,37.7826087 C988.074783,37.7826087 988.165652,37.8734783 988.165652,37.9891304 
                  L988.165652,47.4891304 L988.173913,47.4891304 Z M989.826087,45.0108696 C989.826087,45.1265217 
                  989.735217,45.2173913 989.619565,45.2173913 L989,45.2173913 L989,37.9891304 C989,37.4191304 
                  988.537391,36.9565217 987.967391,36.9565217 L979.285217,36.9565217 L977.533913,34.85 
                  C977.335652,34.6104348 977.046522,34.4782609 976.74087,34.4782609 L974.130435,34.4782609 
                  L974.130435,33.0326087 C974.130435,32.9169565 974.221304,32.826087 974.336957,32.826087 
                  L978.384783,32.826087 C978.442609,32.826087 978.500435,32.8508696 978.541739,32.9004348 
                  L980.235217,34.9326087 C980.433478,35.1721739 980.722609,35.3043478 981.028261,35.3043478 
                  L989.619565,35.3043478 C989.735217,35.3043478 989.826087,35.3952174 989.826087,35.5108696 
                  L989.826087,45.0108696 L989.826087,45.0108696 Z`} 
                  id="Multiple_Folders"></path>
              </g>
          </g>
      </svg>
  );
};

export default ProjectsIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/ProjectsIcon/index.js